/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClosableProducts200ResponseInnerProductsInner
 */
export interface GetClosableProducts200ResponseInnerProductsInner {
    /**
     * 
     * @type {string}
     * @memberof GetClosableProducts200ResponseInnerProductsInner
     */
    product: GetClosableProducts200ResponseInnerProductsInnerProductEnum;
    /**
     * 
     * @type {string}
     * @memberof GetClosableProducts200ResponseInnerProductsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClosableProducts200ResponseInnerProductsInner
     */
    id?: string;
}


/**
 * @export
 */
export const GetClosableProducts200ResponseInnerProductsInnerProductEnum = {
    Bookings: 'BOOKINGS',
    Shop: 'SHOP',
    Uber: 'UBER',
    Glovo: 'GLOVO',
    Flyt: 'FLYT',
    Rappi: 'RAPPI',
    Didi: 'DIDI'
} as const;
export type GetClosableProducts200ResponseInnerProductsInnerProductEnum = typeof GetClosableProducts200ResponseInnerProductsInnerProductEnum[keyof typeof GetClosableProducts200ResponseInnerProductsInnerProductEnum];


/**
 * Check if a given object implements the GetClosableProducts200ResponseInnerProductsInner interface.
 */
export function instanceOfGetClosableProducts200ResponseInnerProductsInner(value: object): value is GetClosableProducts200ResponseInnerProductsInner {
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetClosableProducts200ResponseInnerProductsInnerFromJSON(json: any): GetClosableProducts200ResponseInnerProductsInner {
    return GetClosableProducts200ResponseInnerProductsInnerFromJSONTyped(json, false);
}

export function GetClosableProducts200ResponseInnerProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClosableProducts200ResponseInnerProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'product': json['product'],
        'name': json['name'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function GetClosableProducts200ResponseInnerProductsInnerToJSON(json: any): GetClosableProducts200ResponseInnerProductsInner {
    return GetClosableProducts200ResponseInnerProductsInnerToJSONTyped(json, false);
}

export function GetClosableProducts200ResponseInnerProductsInnerToJSONTyped(value?: GetClosableProducts200ResponseInnerProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'product': value['product'],
        'name': value['name'],
        'id': value['id'],
    };
}

